export default "__VITE_ASSET__636b96d3__"